// La formule, disponible partout sans la faire descendre écran par écran.
//
// POURQUOI UN CONTEXTE ET PAS UNE PROP. Ce n'est pas de la commodité : une prop
// qu'il faut penser à passer est une prop qu'on oublie, et l'oubli se voit ici
// comme un filtre « Tous consultants » dans un produit qui n'a qu'un profil,
// c'est-à-dire un écran cohérent et faux. Le contexte rend l'oubli impossible.
//
// La valeur vient du SERVEUR (`/api/auth/me`), jamais d'un réglage
// d'interface : un utilisateur ne doit pas pouvoir faire réapparaître le
// vivier en bricolant son navigateur. Ce n'est de toute façon qu'un habillage,
// les données étant bornées côté serveur.

import { createContext, useContext } from 'react'

export type Formule = 'console' | 'radar'

/** Ce que le serveur peut annoncer : une formule métier, ou `admin`, le service
 *  d'administration (issue #95), qui n'affiche que sa page et ne monte aucun
 *  écran métier. Seul `App` le voit. */
export type FormuleService = Formule | 'admin'

export interface Contexte {
  formule: Formule
  /** En Radar, MON profil. `null` en console : le BM n'en est aucun. */
  profileId: number | null
}

/** Défaut `console` : c'est la formule complète, donc un composant monté hors
 *  contexte (un test, une page isolée) affiche tout plutôt que rien, et le
 *  défaut se remarque au lieu de masquer silencieusement des fonctions. */
export const FormuleContext = createContext<Contexte>({ formule: 'console', profileId: null })

export function useFormule(): Formule {
  return useContext(FormuleContext).formule
}

/** `true` en formule Radar : on est son propre et unique candidat, donc tout
 *  ce qui sert à CHOISIR un profil parmi d'autres n'a rien à faire à l'écran. */
export function useProfilUnique(): boolean {
  return useFormule() === 'radar'
}

/** MON identifiant de profil, ou `null` hors Radar. Sert aux écrans qui
 *  agissent sur soi : s'évaluer, postuler, se comparer à une offre. */
export function useMonProfil(): number | null {
  return useContext(FormuleContext).profileId
}
